module.exports = __webpack_public_path__ + "media/images/forms-icons/signature-icon-hover-82210ed879a1f9939c92fc2882dd375a.svg";